module.exports = __webpack_public_path__ + "fonts/LatoLatin-Medium.4aecd87d.woff";